import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { PrivacyPolicy, TermsOfService } from "@/pages/Legal";
import Gambling from "@/pages/Gambling";
import Poker from "@/pages/Poker";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/gambling" element={<Gambling />} />
          <Route path="/poker" element={<Poker />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "2px solid #0a0a0a",
            background: "#ffffff",
            color: "#0a0a0a",
            fontFamily: "IBM Plex Sans, sans-serif",
            fontWeight: 600,
            boxShadow: "6px 6px 0px 0px rgba(0,0,0,1)",
          },
        }}
      />
    </div>
  );
}

export default App;
